var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_link",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1503",
    "data-name": "Rectangle 1503",
    width: 26.25,
    height: 17.063,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683",
    "data-name": "Rectangle 1683",
    width: 42,
    height: 42,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_link-2",
    "data-name": "icon_link",
    transform: "translate(11.812 34.125) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3663",
    "data-name": "Groupe 3663",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13444",
    "data-name": "Trac\\xE9 13444",
    d: "M8.56,3.413a5.119,5.119,0,1,0,0,10.238h1.711a1.14,1.14,0,0,1,1.142,1.137v1.139a1.14,1.14,0,0,1-1.142,1.137H8.56A8.532,8.532,0,1,1,8.56,0h1.711a1.14,1.14,0,0,1,1.142,1.139V2.276a1.14,1.14,0,0,1-1.142,1.137Z",
    transform: "translate(0 -0.001)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1502",
    "data-name": "Rectangle 1502",
    d: "M.81,0H11.744a.811.811,0,0,1,.811.811V2.6a.811.811,0,0,1-.811.811H.81A.81.81,0,0,1,0,2.6V.81A.81.81,0,0,1,.81,0Z",
    transform: "translate(6.848 6.825)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13445",
    "data-name": "Trac\\xE9 13445",
    d: "M7.99,8.532A5.127,5.127,0,0,0,2.854,3.413H1.142A1.14,1.14,0,0,1,0,2.276V1.139A1.14,1.14,0,0,1,1.142,0H2.854a8.532,8.532,0,1,1,0,17.064H1.142A1.14,1.14,0,0,1,0,15.925V14.788a1.14,1.14,0,0,1,1.142-1.137H2.854A5.127,5.127,0,0,0,7.99,8.532",
    transform: "translate(14.837 -0.001)",
    fill: "#6639b7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIconLink);
export default __webpack_public_path__ + "static/media/dark-icon-link.a1c94133ba3ffbefba9fb5c544df869b.svg";
export { ForwardRef as ReactComponent };